// components/PlayStationLoader.js
import React from 'react';
import '../PlayStationLoader.css'; // Подключаем CSS файл для стилей
import { Bars } from 'react-loader-spinner';

const PlayStationLoader = () => {
  return (
    <div className="loader-container">
      <div className="loader-text">Game Zone</div>
      <div className="loader-animation">
        <Bars color="#750fb4" height={80} width={80} />
      </div>
    </div>
  );
};

export default PlayStationLoader;
